import { ECPDActions } from 'shared/constants/actionTypes/cpd';
import {
  ECPDChatIdLoadingStatus,
  ECPDDraftStatus,
  ECPDModalType,
  EDealType,
  type TCPDDraftSource,
  type TPikLandingChannel,
} from 'shared/types/redux/cpd';
import { actionGenerator } from 'shared/utils/redux/actionGenerator';

export const changeModalType = actionGenerator<ECPDActions.CHANGE_MODAL_TYPE, ECPDModalType | null>(
  ECPDActions.CHANGE_MODAL_TYPE,
);
export const setCpdPickLandingChannel = actionGenerator<
  ECPDActions.SET_CPD_PIK_LANDING_CHANNEL,
  TPikLandingChannel | null
>(ECPDActions.SET_CPD_PIK_LANDING_CHANNEL);
export const setCpdDraftSource = actionGenerator<ECPDActions.SET_CPD_DRAFT_SOURCE, TCPDDraftSource | null>(
  ECPDActions.SET_CPD_DRAFT_SOURCE,
);
export const setCpdDealType = actionGenerator<ECPDActions.SET_CPD_DEAL_TYPE, EDealType | null>(
  ECPDActions.SET_CPD_DEAL_TYPE,
);
export const setCpdDraftId = actionGenerator<ECPDActions.SET_CPD_DRAFT_ID, number>(ECPDActions.SET_CPD_DRAFT_ID);
export const setCpdDraftStatus = actionGenerator<ECPDActions.SET_CPD_DRAFT_STATUS, ECPDDraftStatus>(
  ECPDActions.SET_CPD_DRAFT_STATUS,
);
export const setCPDChatIdLoadingStatus = actionGenerator<
  ECPDActions.SET_CPD_CHAT_ID_LOADING_STATUS,
  ECPDChatIdLoadingStatus | null
>(ECPDActions.SET_CPD_CHAT_ID_LOADING_STATUS);

export type TChangeModalTypeAction = ReturnType<typeof changeModalType>;
export type TSetCPDPikLandingChannel = ReturnType<typeof setCpdPickLandingChannel>;
export type TSetCPDDealType = ReturnType<typeof setCpdDealType>;
export type TSetCPDDraftSource = ReturnType<typeof setCpdDraftSource>;
export type TSetCPDDraftIdAction = ReturnType<typeof setCpdDraftId>;
export type TSetCPDDraftStatusAction = ReturnType<typeof setCpdDraftStatus>;
export type TSetCPDChatIdLoadingStatusAction = ReturnType<typeof setCPDChatIdLoadingStatus>;

export type TCPDActions =
  | TChangeModalTypeAction
  | TSetCPDPikLandingChannel
  | TSetCPDDealType
  | TSetCPDDraftSource
  | TSetCPDDraftIdAction
  | TSetCPDDraftStatusAction
  | TSetCPDChatIdLoadingStatusAction;
